export { default as ColorfulButton } from './components/colorful-button';
export { default as ColorfulInput } from './components/colorful-input';
export { default as Button } from './components/button';
export { default as Icon } from './components/icon';
export { default as Slot } from './components/slot';
export { default as Table } from './components/table';
export { default as Modal } from './components/modal';
export { default as Input } from './components/input';
export { default as Form } from './components/form';
export { default as Select } from './components/select';
export { default as Checkbox } from './components/checkbox';
export { default as Slider } from './components/slider';
export { default as TimePicker } from './components/time-picker';
export { Typography } from 'antd';
export { InputNumber } from 'antd';
export { Rate } from 'antd';
export { Switch } from 'antd';
const bizCssPrefix = 'bizpack';
export { bizCssPrefix };
